var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOpenClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 16,
    viewBox: "0 0 29 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4207_2435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8693 1.95373L28.3896 12.1645C28.7751 12.5861 28.9893 13.1414 28.9893 13.7378C28.9893 14.3239 28.7751 14.8895 28.3896 15.3111C28.1968 15.5167 27.9719 15.6812 27.7149 15.8046C27.4579 15.9177 27.1902 15.9794 26.9225 15.9794C26.644 15.9794 26.3763 15.9177 26.13 15.8046C25.873 15.6915 25.6481 15.527 25.4553 15.3213L15.9564 5.06941C15.7637 4.86375 15.5388 4.69923 15.2818 4.58612C15.0247 4.47301 14.757 4.41131 14.4893 4.41131C14.2109 4.41131 13.9431 4.47301 13.6968 4.58612C13.4398 4.69923 13.2149 4.86375 13.0222 5.07969L3.55539 15.3419C3.16987 15.7635 2.64513 16 2.08826 16C1.5421 16 1.00665 15.7738 0.621123 15.3522C0.224889 14.9409 0 14.3753 0 13.7789C0 13.1825 0.21418 12.617 0.599705 12.1954L10.0879 1.95373C11.2552 0.709512 12.8294 0 14.4786 0C16.1278 0 17.702 0.699229 18.8693 1.95373Z",
    fill: "#E4DA1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4207_2435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpenClose);
export default __webpack_public_path__ + "static/media/icon-open-close.f858643cc6b673c3cb1089965dd145a9.svg";
export { ForwardRef as ReactComponent };